import { render, staticRenderFns } from "./message-helper.vue?vue&type=template&id=19abadfa&scoped=true"
import script from "./message-helper.vue?vue&type=script&lang=js"
export * from "./message-helper.vue?vue&type=script&lang=js"
import style0 from "./message-helper.vue?vue&type=style&index=0&id=19abadfa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19abadfa",
  null
  
)

export default component.exports